(function () {
  // --- AÑADIDO: Variable de estado ---
  var userWantsSubscription = null; // null = no se ha elegido, false = compra única, true = suscripción
  var DEBUG = false;
  function dbg() { if (!DEBUG) return; console.debug.apply(console, arguments); }

  function debounce(fn, delay) {
    var t;
    return function () {
      var a = arguments, c = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(c, a); }, delay);
    };
  }
  function setHidden(el, h) {
    if (!el) return;
    try {
      if (h) el.style.setProperty("display", "none", "important");
      else el.style.removeProperty("display");
    } catch (e) {}
    if (el.hidden !== !!h) el.hidden = !!h;
    var v = h ? "true" : "false";
    if (el.getAttribute("aria-hidden") !== v) el.setAttribute("aria-hidden", v);
  }

  // --- Helpers reducidos ---
  function isSubscriptionFromSellingPlan(container) {
    var form =
      (container && (container.closest('form[action*="/cart/add"]') || container.closest("form"))) ||
      document.querySelector('form[action*="/cart/add"]') || document.querySelector("form");
    if (!form) return null;
    var sp = form.querySelector('[name="selling_plan"]:enabled, select[name="selling_plan"]');
    if (!sp) return null;
    var val = sp.tagName === "SELECT" ? sp.value : sp.getAttribute("value") || sp.value;
    if (val == null) return null;
    val = String(val).trim();
    if (val === "" || val === "0") return false;
    return true;
  }
  function findRechargeWidget(container) {
    var root = (container && (container.closest(".product__block") || container.closest(".product"))) || document;
    return (root && root.querySelector("recharge-subscription-widget")) || document.querySelector("recharge-subscription-widget");
  }
  function isSubFromShadow(sr) {
    if (!sr) return null;
    var checkedRadio = sr.querySelector('input[type="radio"]:checked');
    if (checkedRadio) {
      var val = checkedRadio.value;
      if (val === "onetime" || val === "one_time" || val === "" || val === "0") return false;
      return true;
    }
    var pressed = sr.querySelector('[data-purchase-option="subscription"][aria-pressed="true"]');
    if (pressed) return true;
    var onetimePressed = sr.querySelector('[data-purchase-option="onetime"][aria-pressed="true"]');
    if (onetimePressed) return false;
    return null;
  }
  function isSubFromHost(widget) {
    if (!widget) return null;
    var v = widget.getAttribute("data-purchase-option") || widget.getAttribute("aria-current-option");
    return v ? v === "subscription" : null;
  }

  // --- Detectar JSON de variantes (igual que antes) ---
  function findVariantJSON(root) {
    try {
      var el = (root && root.querySelector && root.querySelector("[data-variant-json]")) || document.querySelector("[data-variant-json]");
      if (el) {
        var txt = el.textContent || el.innerText || "";
        var parsed = JSON.parse(txt);
        if (Array.isArray(parsed)) return parsed;
        if (parsed && parsed.variants && Array.isArray(parsed.variants)) return parsed.variants;
      }
    } catch (e) { dbg("error parseando [data-variant-json]", e); }
    try {
      if (root && root.querySelector) {
        var scripts = Array.from(root.querySelectorAll('script[type="application/json"]'));
        for (var i = 0; i < scripts.length; i++) {
          try {
            var p = JSON.parse(scripts[i].textContent);
            if (p && (Array.isArray(p.variants) || Array.isArray(p))) return Array.isArray(p) ? p : p.variants;
          } catch (e) {}
        }
      }
      var globalScripts = Array.from(document.querySelectorAll('script[type="application/json"]'));
      for (var j = 0; j < globalScripts.length; j++) {
        try {
          var q = JSON.parse(globalScripts[j].textContent);
          if (q && (Array.isArray(q.variants) || Array.isArray(q))) return Array.isArray(q) ? q : q.variants;
        } catch (e) {}
      }
    } catch (e) {}
    if (window.product && window.product.variants) return window.product.variants;
    if (window.__PRODUCT__ && window.__PRODUCT__.variants) return window.__PRODUCT__.variants;
    return null;
  }

  // --- actualizar precios por botón (idéntica a la tuya) ---
  function actualizarPreciosBotones(isSub, variantes, subscriptionBonus, currentVariant) {
    if (!variantes || !currentVariant) return;
    const botonesConPrecio = document.querySelectorAll(".product__chip .precio-por-bote");
    botonesConPrecio.forEach((spanPrecio) => {
      const boton = spanPrecio.closest(".product__chip");
      const grupoOpciones = boton && boton.closest("[data-option-buttons]");
      if (!boton || !grupoOpciones) return;
      const valorBoton = boton.getAttribute("data-option-value");
      const indiceOpcion = grupoOpciones.getAttribute("data-index");
      const matchUnidad = valorBoton && valorBoton.match(/(bote|botes|bolsa|bolsas|frasco|frascos|caja|cajas)/i);
      let cantidad = 0;
      const matchCantidad = valorBoton && valorBoton.match(/(\d+)/);
      if (matchCantidad) cantidad = parseInt(matchCantidad[1], 10); else cantidad = 1;
      if (!matchUnidad || cantidad <= 1) { spanPrecio.innerHTML = ""; return; }
      let opcionesABuscar = { option1: currentVariant.option1, option2: currentVariant.option2, option3: currentVariant.option3 };
      opcionesABuscar[indiceOpcion] = valorBoton;
      const varianteCorrespondiente = variantes.find((v) => {
        let match = true;
        if (opcionesABuscar.option1 && v.option1 !== opcionesABuscar.option1) match = false;
        if (opcionesABuscar.option2 && v.option2 !== opcionesABuscar.option2) match = false;
        if (opcionesABuscar.option3 && v.option3 !== opcionesABuscar.option3) match = false;
        return match;
      });
      if (varianteCorrespondiente) {
        const precioNumerico = varianteCorrespondiente.price / 100;
        const precioPorUnidad = precioNumerico / cantidad;
        const precioSub = precioPorUnidad * (1 - (subscriptionBonus || 0) / 100);
        spanPrecio.innerHTML = isSub ? `${Math.round(precioSub)}c/u.` : `${Math.round(precioPorUnidad)}c/u.`;
      } else {
        spanPrecio.innerHTML = "";
      }
    });
  }

  // --- SETUP por cada container (optimizado) ---
  function setup(container) {
    if (!container || container.__discountBound) return;
    container.__discountBound = true;
    dbg("setup en container", container);

    // flags y storage
    container.__suppressMutations = false;

    var elComparePriceForFormat = container.querySelector("[data-compare-price]");
    var initialText = elComparePriceForFormat ? elComparePriceForFormat.textContent : "$0.00";
    var currencySymbol = initialText.trim().match(/^([^0-9.,]+)/);
    currencySymbol = currencySymbol ? currencySymbol[1] : "$";
    var decimals = 0;
    function formatPrice(number) { return currencySymbol + number.toFixed(decimals); }

    function read() {
      var sale = 0, min = 0, sub = 0;
      var stdEl = container.querySelector("[data-discount-display]");
      if (stdEl) {
        var text = stdEl.textContent || stdEl.innerText || "";
        var match = text.match(/(\d+(\.\d+)?)/);
        if (match && match[1]) sale = parseFloat(match[1]);
      }
      var dynEl = container.querySelector(".js-dynamic-discount");
      if (dynEl) {
        var su = parseFloat(dynEl.getAttribute("data-sub"));
        if (!isNaN(su)) sub = su;
      }
      return { sale: sale, min: min, sub: sub };
    }

    function trackUserIntent(e) {
      var el = e.target;
      var clickedRadio = el.closest && el.closest('input[type="radio"]');
      var clickedButton = el.closest && el.closest('[data-purchase-option]');
      var altBtn = el.closest && el.closest('.product__chip, .dynamic-variant-button');
      if (clickedRadio) {
        if (clickedRadio.value === "onetime" || clickedRadio.value === "one_time" || clickedRadio.value === "0" || clickedRadio.value === "") {
          userWantsSubscription = false;
        } else {
          userWantsSubscription = true;
        }
      } else if (clickedButton) {
        var option = clickedButton.getAttribute('data-purchase-option');
        if (option === 'onetime') userWantsSubscription = false;
        else if (option === 'subscription') userWantsSubscription = true;
      } else if (altBtn) {
        // forzamos update (debounced)
        debouncedUpdate();
      }
    }

    // update principal (sin observers internos)
    function doUpdate() {
      try {
        var root = container.closest(".product__block") || container.closest(".product") || document;
        var widget = findRechargeWidget(root);
        if (widget && widget !== container.__boundWidget) {
          // listeners ligeros sobre widget
          widget.addEventListener("change", debouncedUpdate, true);
          widget.addEventListener("click", debouncedUpdate, true);
          if (widget.shadowRoot) {
            widget.shadowRoot.addEventListener("click", trackUserIntent, true);
          }
          widget.addEventListener("click", trackUserIntent, true);
          container.__boundWidget = widget;
        }

        var form = (root && (root.querySelector('form[action*="/cart/add"]') || root.querySelector("form"))) || document.querySelector('form[action*="/cart/add"]') || document.querySelector("form");
        var currentVariantIdInput = form && form.querySelector ? form.querySelector('[name="id"]') : document.querySelector('[name="id"]');
        var elSalePrice = (container && container.querySelector("[data-price]")) || (root && root.querySelector && root.querySelector("[data-price]")) || document.querySelector("[data-price]");
        var std = container.querySelector(".js-standard-discount");
        var dyn = container.querySelector(".js-dynamic-discount");
        var variantes = findVariantJSON(root);

        var st = read();

        var currentVariant = null;
        if (variantes && currentVariantIdInput) {
          var currentVariantId = String(currentVariantIdInput.value || currentVariantIdInput.getAttribute("value") || "");
          currentVariant = variantes.find(function (v) { return String(v.id) === currentVariantId; });
          if (!currentVariant) {
            currentVariant = variantes.find(function (v) { return String(v.sku) === currentVariantId || String(v.title) === currentVariantId; });
          }
        }

        // Restaurar el span .js-dynamic-discount si el tema lo eliminó
        if (!dyn && elSalePrice) {
          // crear nuevo
          dyn = document.createElement('span');
          dyn.className = 'js-dynamic-discount';
          dyn.setAttribute('aria-hidden', 'false');
          // insertarlo después del std si existe, sino después del elSalePrice
          if (std && std.parentElement) std.parentElement.insertBefore(dyn, std.nextSibling);
          else if (elSalePrice.parentElement) elSalePrice.parentElement.appendChild(dyn);
        }

        if (!currentVariant || !elSalePrice) {
          // aún no hay datos completos; intentar reintentar pronto
          return;
        }

        var oneTimeSalePrice = (currentVariant.price || currentVariant.compare_at_price || 0) / 100;
        var oneTimeSalePriceText = formatPrice(oneTimeSalePrice);

        var actualIsSub = isSubscriptionFromSellingPlan(container);
        if (actualIsSub === null) {
          actualIsSub = widget && widget.shadowRoot ? isSubFromShadow(widget.shadowRoot) : null;
          if (actualIsSub === null) actualIsSub = isSubFromHost(widget);
        }
        actualIsSub = !!actualIsSub;

        var isSub;
        if (userWantsSubscription === null) {
          isSub = actualIsSub;
          userWantsSubscription = actualIsSub;
        } else if (userWantsSubscription === true && actualIsSub === false) {
          // intentar sincronizar input/radio, pero no crear bucles
          var subButton = widget && widget.shadowRoot ? widget.shadowRoot.querySelector('input[type="radio"][value="subscription"]') : (widget ? widget.querySelector('input[type="radio"][value="subscription"]') : null);
          if (subButton) {
            subButton.checked = true;
            subButton.dispatchEvent(new Event('change', { bubbles: true }));
            // dejamos isSub = true para el cálculo inmediato
            isSub = true;
          } else isSub = true;
        } else if (userWantsSubscription === false && actualIsSub === true) {
          var oneTimeButton = widget && widget.shadowRoot ? widget.shadowRoot.querySelector('input[type="radio"][value="onetime"], input[type="radio"][value="one_time"]') : (widget ? widget.querySelector('input[type="radio"][value="onetime"], input[type="radio"][value="one_time"]') : null);
          if (oneTimeButton) {
            oneTimeButton.checked = true;
            oneTimeButton.dispatchEvent(new Event('change', { bubbles: true }));
            isSub = false;
          } else isSub = false;
        } else {
          isSub = userWantsSubscription;
        }

        var subscriptionBonus = 0;
        if (isSub) {
          var badgeEl = widget && widget.shadowRoot ? widget.shadowRoot.querySelector(".rc-purchase-option__badge") : null;
          if (!badgeEl) badgeEl = container.querySelector(".rc-purchase-option__badge") || container.querySelector(".js-dynamic-discount");
          if (badgeEl) {
            var text = badgeEl.textContent || badgeEl.innerText || "";
            var match = text.match(/(\d+(\.\d+)?)/);
            if (match && match[1]) subscriptionBonus = parseFloat(match[1]);
          }
        }

        // Ahora actualizamos DOM solo si hay cambios (y suprimimos observer mientras lo hacemos)
        // Calculamos los valores
        var base = Math.round(st.sale || 0);
        var extra = Math.round(subscriptionBonus || 0);
        var total = base + extra;
        var txt = base > 0 ? ` ${total}% con suscripción` : `+ ${extra}% con suscripción`; txt = ''; // Ocultar temporalmente el texto

        var shouldShowDyn = isSub && (extra > 0 || base > 0);


        // Si no hay dyn aún, ya lo creamos arriba; ahora sólo modificar texto/visibilidad
        if (dyn) {
          // suprimir mientras cambiamos
          container.__suppressMutations = true;
          try {
            if (dyn.textContent !== txt) dyn.textContent = txt;
            setHidden(dyn, !shouldShowDyn);
            // ocultar o mostrar el descuento base
            const baseDiscount = container.querySelector('.js-standard-discount');
           if (baseDiscount) {
  // Solo ocultar si realmente estamos en modo suscripción y el extra es válido
  if (isSub && extra < 0) {
    baseDiscount.style.display = 'none';
  } else {
    baseDiscount.style.display = '';
  }
}
            // actualizar precio mostrado (resultado con suscripción si aplica)
            if (isSub && subscriptionBonus > 0 && oneTimeSalePrice > 0) {
              var precioCalculadoSub = oneTimeSalePrice * (1 - subscriptionBonus / 100);
              elSalePrice.textContent = formatPrice(precioCalculadoSub);
            } else {
              elSalePrice.textContent = oneTimeSalePriceText;
            }
          } finally {
            // restaurar suppression después de un tick
            setTimeout(function () { container.__suppressMutations = false; }, 60);
          }
        }

        // actualizar chips
        actualizarPreciosBotones(isSub, variantes, subscriptionBonus, currentVariant);

      } catch (err) {
        console.error("Error en doUpdate:", err);
      }
    } // fin doUpdate

    var debouncedUpdate = debounce(doUpdate, 120);

    // Observer solo sobre este container (mucho más ligero)
    var mo = new MutationObserver(function (mutations) {
      if (container.__suppressMutations) return;
      // Si detectamos añadidos o cambios relevantes re-ejecutamos (debounced)
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
          debouncedUpdate();
          return;
        }
        if (m.type === 'attributes' && (m.attributeName === 'class' || m.attributeName === 'value' || m.attributeName === 'data-purchase-option')) {
          debouncedUpdate();
          return;
        }
      }
    });
    mo.observe(container, { childList: true, subtree: true, attributes: true, characterData: false });
    container.__mo = mo;

    // Listeners locales
    container.addEventListener('click', trackUserIntent, true);
    // delegación para chips (si existen dentro)
    container.addEventListener('click', function (e) {
      var chip = e.target && e.target.closest && e.target.closest('.product__chip');
      if (chip) {
        // manejar la clase selected localmente si el theme no lo hace instantáneo
        container.querySelectorAll('.product__chip').forEach(function (b) { b.classList.remove('selected'); });
        chip.classList.add('selected');
        debouncedUpdate();
      }
    }, true);

    // también responder a cambios de variant id
    document.addEventListener('change', function (e) { if (e.target && e.target.name === "id") debouncedUpdate(); }, true);
    window.addEventListener('variant:change', debouncedUpdate);
    document.addEventListener('shopify:section:load', debouncedUpdate);

    // ejecución inicial ligera
    setTimeout(debouncedUpdate, 50);
  } // fin setup

  function initAll() {
    document.querySelectorAll(".product__price-and-ratings").forEach(setup);
  }
  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
  // init si ya está el DOM
  setTimeout(initAll, 100);

  
})();
